// extracted by mini-css-extract-plugin
module.exports = {"pillRow":"show-more-pill_pillRow__NEVwN","pill":"show-more-pill_pill__PWzbz"};